import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../Redux/store";

const initialState = {
    isWelcomeModalOpen: false,
}

const welcomeUISlice = createSlice({
    name: 'welcomeUI',
    initialState,
    reducers: {
        openWelcomeModal: (state) => {
            state.isWelcomeModalOpen = true;
        },
        closeWelcomeModal: (state) => {
            state.isWelcomeModalOpen = false;
        },
    },
});

export const welcomeReducer = welcomeUISlice.reducer;

export const { openWelcomeModal, closeWelcomeModal } = welcomeUISlice.actions;
export const selectWelcomeModalOpen = (state: RootState) => state.welcomeUI.isWelcomeModalOpen;